import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import RecoverySvg from '../../../assets/icons/nav/recovery.svg?raw';

export const RecoveryIcon = (props) => <CustomSVG svg={RecoverySvg} preserveColors {...props} />;
